import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import FormControl from 'react-bootstrap/lib/FormControl';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import FooterButton from './FooterButton';
import SidePanel from './SidePanel';
import updateStep3 from './updateStep3';
import stepMoneyIllustration from '/public/SiteImages/step-money.svg';

import { normalizePrice } from '../../helpers/normalizePrice';
import validateStep3 from './validateStep3';


import bt from '../../components/commonStyle.css';
import s from './ListPlaceStep1.css';

class Pricing extends Component {

  static propTypes = {
    previousPage: PropTypes.any,
    nextPage: PropTypes.any
  };

  constructor(props) {
    super(props);
    this.state = {
      isDisabled: true,
    };
  }

  UNSAFE_componentWillMount() {
    const { valid } = this.props;
    this.setState({ isDisabled: valid ? false : true })
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { valid } = nextProps;
    this.setState({ isDisabled: valid ? false : true })
  }

  /* renderFormControlTax = ({ input, label, type, meta: { touched, error }, className, prefixLabel }) => {
    const { formatMessage } = this.props.intl;
    return (
      <div>
        <InputGroup>
          <FormControl {...input} placeholder={label} type={type} className={className} maxLength={12} />
          <InputGroup.Addon className={s.prefixIcon}>{prefixLabel}</InputGroup.Addon>
        </InputGroup>
        {touched && error && <span className={s.errorMessage}>{formatMessage(error)}</span>}
      </div>
    )
  } */

  renderFormControlSelect = ({ input, label, meta: { touched, error }, children, className }) => {
    const { formatMessage } = this.props.intl;
    return (
      <div>
        <FormControl componentClass="select" {...input} className={className} >
          {children}
        </FormControl>
      </div>
    )
  }

  renderPriceInput = ({ input, placeholder, meta: { touched, error } }) => {
    const { formatMessage } = this.props.intl;
    return (
      <div style={{ flex: 1 }}>
        <input
          {...input}
          type="text"
          placeholder={placeholder}
          className={s.pricingInputField}
        />
        {touched && error && <span className={s.errorMessage}>{formatMessage(error)}</span>}
      </div>
    );
  };

  render() {
    const { handleSubmit, nextPage, previousPage, formPage, step, availableCurrencies } = this.props;
    const { isDisabled } = this.state;
    const { formatMessage } = this.props.intl;

    let currencySymbol = 'Bs.';
    if (availableCurrencies && availableCurrencies.length > 0) {
      const enabledCurrency = availableCurrencies.find(c => c.isEnable === true);
      if (enabledCurrency) {
        currencySymbol = enabledCurrency.symbol;
      }
    }

    return (
      <div className={s.eslipinBg}>
        <div className={s.grid}>
          <SidePanel
            badge="Información del alojamiento"
            title={`Ahora lo divertido, \npongamos el \n`}
            highlightText="precio por noche"
            subtitle="Considera empezar con un precio atractivo para destacarte frente a otros espacios."
            iconImg={stepMoneyIllustration}
          />
          <form onSubmit={handleSubmit}>
            <div className={cx(s.stepRightCard, s.pricingStepCard)}>
              <div className={s.landingMainContent}>

                {/* Precio por noche */}
                <div className={s.pricingSectionBlock}>
                  <div className={s.pricingSectionHeader}>
                    <div className={s.pricingSectionIcon}>
                      <img src="/SiteIcons/etiqueta-colgante.svg" width="70" height="70" />
                    </div>
                    <div className={s.pricingSectionText}>
                      <h2 className={s.pricingSectionTitle}>Precio por noche</h2>
                      <p className={s.pricingSectionSubtitle}>Ingresa el precio base por noche de tu alojamiento.</p>

                      <div className={s.pricingInputBox}>
                        <span className={s.pricingCurrencyLabel}>{currencySymbol}</span>
                        <Field
                          name="basePrice"
                          type="text"
                          component={this.renderPriceInput}
                          normalize={normalizePrice}
                          placeholder="0"
                        />
                      </div>
                    </div>
                  </div>


                </div>

                <hr className={s.pricingDivider} />

                {/* Tarifa de limpieza */}
                <div className={s.pricingSectionBlock}>
                  <div className={s.pricingSectionHeader}>
                    <div className={s.pricingSectionIcon}>
                      <img src="/SiteIcons/limpieza.svg" width="70" height="70" />
                    </div>
                    <div className={s.pricingSectionText}>
                      <h2 className={s.pricingSectionTitle}>Tarifa de limpieza</h2>
                      <p className={s.pricingSectionSubtitle}>La tarifa de limpieza se sumará al monto final de la reserva del huésped.</p>

                      <div className={s.pricingInputBox}>
                        <span className={s.pricingCurrencyLabel}>{currencySymbol}</span>
                        <Field
                          name="cleaningPrice"
                          type="text"
                          component={this.renderPriceInput}
                          normalize={normalizePrice}
                          placeholder="0"
                        />
                      </div>
                    </div>
                  </div>


                </div>

              </div>

              <FooterButton
                nextPage={nextPage}
                previousPage={previousPage}
                nextPagePath={"discount"}
                previousPagePath={"min-max-nights"}
                formPage={formPage}
                step={step}
                isDisabled={isDisabled}
              />
            </div>
          </form>
        </div>
      </div>
    );
  }
}

Pricing = reduxForm({
  form: 'ListPlaceStep3', // a unique name for this form
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  validate: validateStep3,
  onSubmit: updateStep3
  // onSubmit: updateStep4

})(Pricing);

const mapState = (state) => ({
  listingFields: state.listingFields.data,
  availableCurrencies: state?.currency?.availableCurrencies?.results,
  base: state.currency.base,
  mapUpdateLoading: state.location.mapUpdateLoading
});

const mapDispatch = {};

export default injectIntl(withStyles(s, bt)(connect(mapState, mapDispatch)(Pricing)));